import React from 'react'
import Table, { Cell, Header, Row } from 'components/Table'
import { ORDER_STATUS } from 'pages/operations/SaleOrders/Details/ReDelivery/constant'
import { getPrintableTime, getOnlyTime } from 'lib/datetime'

const formatMoney = (n) => (n != null ? `$${Number(n).toFixed(2)}` : '$0.00')

export const formatDisplayText = (str = '', prefix = '') =>
  str
    ?.replace(prefix, '')
    .replaceAll('_', ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase())

const getDate = (dt) => (dt ? getPrintableTime(dt).split(', ')[0] : '')

const TransactionsTable = ({ transactions = [] }) => {
  const sortedTransactions = React.useMemo(() => {
    const copy = [...transactions]
    copy.sort(
      (a, b) =>
        new Date(a.createTime).getTime() - new Date(b.createTime).getTime()
    )
    return copy
  }, [transactions])

  if (transactions.length === 0) {
    return (
      <div className="transactions-container">
        <h3>Transactions</h3>
        <div className="text-muted">No transactions found</div>
      </div>
    )
  }

  return (
    <div className="transactions-container scrollable-table">
      <h3>Transactions</h3>
      <Table>
        <Header>
          <Cell>Transaction Type</Cell>
          <Cell>Payment Method</Cell>
          <Cell className="text-right">Amount</Cell>
          <Cell className="text-right">State</Cell>
          <Cell>Time</Cell>
        </Header>

        {sortedTransactions.map((transaction) => {
          const category = formatDisplayText(
            transaction.category,
            'TRANSACTION_CATEGORY_'
          )
          const method = formatDisplayText(
            transaction.method,
            'TRANSACTION_METHOD_'
          )
          const state =
            ORDER_STATUS[transaction.state] ||
            formatDisplayText(transaction.state, 'STATE_')

          return (
            <Row key={transaction.id} testId="transaction-row">
              <Cell>{category}</Cell>
              <Cell>{method}</Cell>
              <Cell className="text-right">
                {formatMoney(transaction.amount)}
              </Cell>
              <Cell className="text-right">{state.toUpperCase()}</Cell>
              <Cell>
                {`${getDate(transaction.createTime)} ${getOnlyTime(transaction.createTime)}`}
              </Cell>
            </Row>
          )
        })}
      </Table>
    </div>
  )
}

export default TransactionsTable
